import React from 'react';
import { observer } from 'mobx-react';
import Bugsnag from '@bugsnag/js';

import useStores from 'jsx/utils/hooks/useStores';
import type SignupUserStore from 'jsx/signup/stores/signupUser';
import type UserStore from 'jsx/stores/userStore';
import errorReporter from 'jsx/utils/errorReporter';
import { isDefined } from 'jsx/utils/isDefined';

import InternalError from '../errors/internalError';

/**
 * We call Bugsnag.start with the React integration when we instantiate
 * the `errorReporter` which means we won't get undefined here.
 */
const BugsnagErrorBoundary =
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  Bugsnag.getPlugin('react')!.createErrorBoundary(React);

const ErrorBoundary: React.FC<{ showError?: boolean }> = ({
  children,
  showError = true,
}) => {
  /**
   * Returns `undefined` if there is no MobXProviderContext available
   */
  const { userStore } = useStores<SignupUserStore | UserStore | undefined>();

  if (isDefined(userStore) && userStore.patient.id >= 0) {
    errorReporter.setUser(userStore.patient);
  }

  const fallback = showError ? InternalError : undefined;

  return (
    <BugsnagErrorBoundary FallbackComponent={fallback}>
      {children}
    </BugsnagErrorBoundary>
  );
};

export default observer(ErrorBoundary);
